import config from "@/utils/config";
import moment from "moment/moment";
import request from "@/utils/request";

// 冬枣服务绑定站点列表
const getStations = (types: string) => {
  const params = {
    types,
    regionIds: "1",
  };
  return request
    .get("/admin/station/query", params)
    .then((data) => {
      if (data.data && data.data.length > 0) {
        return data.data;
      }
      return [];
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
};

//生育期查询
const getGrowthPeriod = (type: string) => {
  return request
    .get("/admin/growth/current_period/" + type)
    .then((data) => {
      console.log(data)
      if (data.data) {
        return data.data;
      }
      return [];
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
};
//生育期生产
const getGrowthSystem = (type: string) => {
  const params = {
    growType: type,
  };
  return request
    .get("/admin/growth/system", params)
    .then((data) => {
      if (data.data) {
        return data.data;
      }
      return [];
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
};

export default {
  getStations,
  getGrowthSystem,
  getGrowthPeriod,
};
